import _ from 'lodash'
import enabled from './enabled'
import values from './values'

export default (form, category) => (
  _.sum(values(enabled(form, category)))
)
